import { SET_USER_HASH, USER_HASH_EXPIRED } from '../../actions/userDataActions';

const userHashReducer = (state = {
    userHashExpired: false,
    value: null
  }, action) => {
    switch (action.type) {
      case SET_USER_HASH:
        state = {
          ...state,
          value:  action.payload
        };
        break;
      case USER_HASH_EXPIRED:
        state = {
          ...state,
          userHashExpired:  true
        };
        break;
      default:
        break;
    }
    return state;
  }
  
  export default userHashReducer;
  